import React from 'react'

import { ListItemGeneralSDUI } from './ListItemGeneralSDUI'
import { ListItemSDUIRendererBase } from '../hooks/ListItemSDUIRendererBase'
import type { SDUIComponentProps } from '../interfaces'

interface ListItemGeneralSDUIRendererProps {
  sduiComponent: SDUIComponentProps
}

export const ListItemGeneralSDUIRenderer: React.FC<ListItemGeneralSDUIRendererProps> = ({
  sduiComponent,
}) => (
  <ListItemSDUIRendererBase
    sduiComponent={sduiComponent}
    inlineItems={(sduiComponent.props?.items ?? []) as ListItemGeneralData[]}
    Component={ListItemGeneralSDUI}
  />
)
